'use client';

import { c as _c } from "react/compiler-runtime";
import type { HeaderLinkRenderProps } from '@sprd/spreadshirt-shell';
import { type MouseEvent, useState } from 'react';
import Link from 'next/link';
import { rewriteLinkIfNeeded } from '@/components/Common/AmplienceLink';

/** Prefetches only once hovered: the header is on every page and carries hundreds of links. */
export const HeaderLinkAdapter = t0 => {
  const $ = _c(13);
  let href;
  let onMouseEnter;
  let rest;
  if ($[0] !== t0) {
    ({
      href,
      onMouseEnter,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = onMouseEnter;
    $[3] = rest;
  } else {
    href = $[1];
    onMouseEnter = $[2];
    rest = $[3];
  }
  const [hovered, setHovered] = useState(false);
  let t1;
  if ($[4] !== href) {
    t1 = rewriteLinkIfNeeded(href);
    $[4] = href;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = hovered ? null : false;
  let t3;
  if ($[6] !== onMouseEnter) {
    t3 = event => {
      setHovered(true);
      onMouseEnter?.(event);
    };
    $[6] = onMouseEnter;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== rest || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <Link href={t1} prefetch={t2} onMouseEnter={t3} {...rest} />;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};